import React from 'react';

import HeaderSecondary from '@components/HeaderSecondary';
import SubHeader from '@components/HealthQuoteResultPage/SubHeader';
import { useQuoteOptionParams } from '@components/Feature/HealthQuote/hook';
import { routePersonalAccidentQuotePage } from '@components/HealthQuotePage';

import PersonalAccidentQuoteList from './PersonalAccidentQuoteList';
import ComparablePersonalAccidentQuote from './ComparablePersonalAccidentQuote';

const PersonalAccidentQuoteResultPage = () => {
  const params = useQuoteOptionParams();

  return (
    <>
      <HeaderSecondary />
      <SubHeader formLinkTo={routePersonalAccidentQuotePage({ path: 'members', ...params })} />
      <PersonalAccidentQuoteList />
      <ComparablePersonalAccidentQuote />
    </>
  );
};

export { PersonalAccidentQuoteResultPage };
